import { jsxs, jsx } from "react/jsx-runtime";
import { Stack, Notice, Inline, Text, TextLinkButton, Box, Divider, Columns, Column } from "braid-design-system";
import { StepButtons } from "../StepButtons/index.mjs";
import { useTranslations } from "@vocab/react";
import { translations } from "../../../../../private/components/Stepper/.vocab/index.mjs";
import { stickyFooter } from "./index.css.mjs";
const StepFooterContent = ({
  footerNotification,
  errorMessage,
  handleError
}) => {
  const { t } = useTranslations(translations);
  return /* @__PURE__ */ jsxs(Stack, { space: "medium", align: ["right", "right", "left"], children: [
    errorMessage ? /* @__PURE__ */ jsx(Notice, { tone: "critical", children: /* @__PURE__ */ jsxs(Inline, { space: "small", children: [
      /* @__PURE__ */ jsx(Text, { children: errorMessage }),
      handleError && /* @__PURE__ */ jsx(Text, { children: t("Please return to main page", {
        Link: (children) => /* @__PURE__ */ jsx(TextLinkButton, { onClick: handleError, children })
      }) })
    ] }) }) : null,
    !Boolean(errorMessage) && footerNotification ? /* @__PURE__ */ jsx(Box, { children: footerNotification }) : null
  ] });
};
const StepFooter = ({
  stepIndex,
  totalSteps,
  footerNotification,
  saveButtonLabel,
  isLoading = false,
  onClickBack,
  onClickNext,
  onClickCancel,
  errorMessage,
  handleError
}) => /* @__PURE__ */ jsxs(
  Box,
  {
    position: "absolute",
    width: "full",
    className: stickyFooter,
    background: "surface",
    paddingX: "large",
    children: [
      /* @__PURE__ */ jsx(Divider, {}),
      /* @__PURE__ */ jsx(Box, { paddingY: "medium", children: /* @__PURE__ */ jsxs(Columns, { collapseBelow: "desktop", space: "medium", alignY: "center", reverse: true, children: [
        handleError ? null : /* @__PURE__ */ jsx(Column, { width: "2/5", children: /* @__PURE__ */ jsx(
          StepButtons,
          {
            stepIndex,
            totalSteps,
            isLoading,
            onClickBack,
            onClickNext,
            onClickCancel,
            saveButtonLabel
          }
        ) }),
        /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsx(
          StepFooterContent,
          {
            footerNotification,
            errorMessage,
            handleError
          }
        ) })
      ] }) })
    ]
  }
);
export {
  StepFooter
};
